import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import AppUIDetail from './AppUIDetail'
import {uploadAction, uploadReset} from 'actions/uploadAction';
import { createNewAppTranslation, createNewAppUI, updateAppUIConfig, updateNewAppTranslation, deleteAppTranslation } from "actions/appUIAction";
import * as tourActions from 'actions/tourAction';

const mapStateToProps = state => {
    return {
        uploadState: state.uploadReducer,
        appUIState: state.appUIReducer,
        tourState: state.tourReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllTourTypes: () => dispatch(tourActions.getAllTourTypes()),
        //! FILE
        uploadFile: (filters) => dispatch(uploadAction(filters)),
        uploadReset: () => dispatch(uploadReset()),
        //! APP Actions
        createNewAppUI: (appUIData) => dispatch(createNewAppUI(appUIData)),
        updateAppUIConfig: (appUIData) => dispatch(updateAppUIConfig(appUIData)),
        //! APP Translate
        createNewAppTranslation: (appUIData) => dispatch(createNewAppTranslation(appUIData)),
        updateNewAppTranslation: (appUIData) => dispatch(updateNewAppTranslation(appUIData)),
        deleteAppTranslation: (appUIData) => dispatch(deleteAppTranslation(appUIData))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(AppUIDetail));
